import { BrowserRouter, Routes, Route } from "react-router"
import { SenderPage } from "./pages/SenderPage"
import { ReplayPage } from "./pages/ReplayPage"

export const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<SenderPage />} />
        <Route path="/r/:id" element={<ReplayPage />} />
      </Routes>
    </BrowserRouter>
  )
}
